import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { FC } from 'react'
import PlatformDisplayName from '../PlatformDisplayName/PlatformDisplayName'

interface HeaderProps {
  'data-testid'?: string
  title: string
  subtitle: string
  showPlatformDisplayName?: boolean
}

const Header: FC<HeaderProps> = ({
  'data-testid': testid,
  title,
  subtitle,
  showPlatformDisplayName = false,
}: HeaderProps) => (
  <Box
    data-testid={testid}
    sx={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      width: '100%',
      [useTheme().breakpoints.down('md')]: {
        flexDirection: 'column',
      },
    }}
  >
    <Box sx={{ flex: 9, display: 'flex' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <Typography variant="h2" component="h1" sx={{ mb: 1.5 }}>
          {title}
        </Typography>
        <Typography variant="bodyLarge" component="h2" sx={{ mb: 2.5 }}>
          {subtitle}
        </Typography>
      </Box>
    </Box>
    {showPlatformDisplayName && (
      <Box
        sx={{
          flex: 3,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          height: '6rem',
          [useTheme().breakpoints.down('md')]: {
            mb: 2,
          },
        }}
      >
        <PlatformDisplayName />
      </Box>
    )}
  </Box>
)

export default Header
